<template>
  <b-table
    :data="credits"
    hoverable
    narrowed
    @click="openCreditDetails"
    style="cursor: pointer"
  >
    <b-table-column field="createdAt" :label="$t('common.date')" v-slot="props">
      {{
        new Date(props.row.createdAt).toLocaleDateString(
          undefined,
          transactionDateFormat
        )
      }}
    </b-table-column>

    <b-table-column
      field="user.personalInfo.name"
      :label="$t('common.user')"
      v-slot="props"
    >
      <span v-if="permissions.seeStoreClientName">
        {{
          `${props.row.user.personalInfo.name}${
            permissions.seeStoreClientSurname
              ? ` ${props.row.user.personalInfo.surname}`
              : ""
          }${
            props.row.user.personalInfo.socialName
              ? ` (${$t("common.socialName")}: ${
                  props.row.user.personalInfo.socialName
                })`
              : ""
          }`
        }}
      </span>

      <span v-else>{{ props.row.user._id }}</span>
    </b-table-column>

    <b-table-column
      field="store.storeInfo.name"
      :label="$t('credits.store')"
      v-slot="props"
    >
      {{ props.row.store.storeInfo.name }}
    </b-table-column>

    <b-table-column field="value" :label="$t('common.value')" v-slot="props">
      {{ `${payments.currencySymbol} ${formatMoney(props.row.value)}` }}
    </b-table-column>

    <b-table-column
      field="royalty.value"
      :label="$t('credits.royalty')"
      v-slot="props"
    >
      {{ `${payments.currencySymbol} ${formatMoney(props.row.royalty.value)}` }}
    </b-table-column>

    <b-table-column
      field="royalty.status"
      :label="$t('common.status')"
      v-slot="props"
    >
      <button
        class="button is-small"
        :class="
          props.row.royalty.status === 'open'
            ? 'is-warning'
            : props.row.royalty.status === 'paid'
            ? 'is-success'
            : props.row.royalty.status === 'free'
            ? 'is-info'
            : 'is-light'
        "
      >
        {{
          props.row.royalty.status === "open"
            ? $t("credits.open")
            : props.row.royalty.status === "paid"
            ? $t("credits.paid")
            : props.row.royalty.status === "free"
            ? $t("credits.exempt")
            : "-"
        }}
      </button>
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";
import tableEmptyTemplate from "../../common/TableEmptyTemplate";

export default {
  mixins: [common, mask],

  props: ["credits"],

  components: {
    tableEmptyTemplate
  },

  data() {
    return {
      transactionDateFormat: {
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }
    };
  },

  methods: {
    openCreditDetails(credit) {
      this.$emit("open-credit-details", credit._id);
    }
  },

  computed: {
    ...mapGetters(["payments", "permissions"])
  }
};
</script>
